import axios from "axios";
import { Api } from '../../../Config/config.js';
import {myBusinessUpdatedSuccess, myBusinessUpdatedFail, myBusinessDataSuccess, myBusinessDataFailed} from "../../constant";
import {store} from "../../store";


export const myBusinessData = async (dispatch, id) => {
    try {
        const response = await axios.get(`${Api}accounts/${id}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer '+ store.getState().authReducer.tokens.access.token
            },
        });

        dispatch({
            type: myBusinessDataSuccess,
            payload: response.data,
        });

    } catch (error) {
        dispatch({
            type: myBusinessDataFailed,
            payload: error.response.data,
        });
    }
};
export const myBusinessUpdate = async (dispatch, id, data) => {
    try {
        const response = await axios.patch(`${Api}accounts/${id}`, data, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer '+ store.getState().authReducer.tokens.access.token
            },
        })

        dispatch({
            type: myBusinessUpdatedSuccess,
            payload: response.data,
        });

    } catch (error) {
        dispatch({
            type: myBusinessUpdatedFail,
            payload: error.response.data,
        });
    }
};
